import React, {PureComponent} from 'react';
import './tips.scss';
import pubsub from 'common/js/pubsub';
import logger from 'common/js/logger';
import loginUtil from 'common/js/login';

export default class Tips extends PureComponent {
	constructor(props) {
		super(props)
		this.state={
			msg: props.msg,
			type: props.type,
			phone: props.phone,
			password:props.password
		}

		this.login = this.login.bind(this);
	}

	componentDidMount() {
		this._mounted = true;
	}

	componentWillUnmount() {
		this._mounted = false;
	}

	componentWillReceiveProps(nextProps) {
		this.state={
			msg: nextProps.msg,
			type: nextProps.type,
			phone: nextProps.phone,
			password:nextProps.password
		}
	}

	login() {
		let phone = this.state.phone,
			password = this.state.password;

		if( phone && password) {
			loginUtil.accountLogin({
				userName: phone,
				password: password,
				success: function(res) {
					loginUtil.refreshUserInfo();
					pubsub.publish('showSuccessTips', {
						msg: '登录成功',
						type: 'login'
					});
				},
				fail: function(res) {
					pubsub.publish('showLoginTab');
				}
			})
		}else{
			pubsub.publish('showLoginTab');
		}

	}

	render() {
		return (
			<div className="m-form-tips">
				<div className="s-icon_finish"></div>
				<div className="s-tips">
					{this.state.msg}
				</div>
				{this.state.type === "reg" ?<div className="s-btn_box">
							<a className="btn-finish" href="javascript:void(0)" onClick={this.login}>立即登录</a>
						</div> : ""}
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/views/login/tips/Tips.jsx